<template>
  <div class="page-container mt-4">
    <section>
      <withdrawal-account v-if="me" :me="me"></withdrawal-account>
    </section>
  </div>
</template>

<script>
import WithdrawalAccount from '@/components/bank/Withdrawal.vue'
import { mapState } from 'vuex'

export default {
  components: { WithdrawalAccount },
  computed: {
    ...mapState('auth', ['me', 'meRefreshKey']),
  },
  created() {
    _meta({
      titles: ['출금계좌확인'],
    })
  },
}
</script>
